export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6880.49cfb655.jpg";